module.exports = __webpack_public_path__ + "static/media/blog-1.ecd4cd12.jpg";